export const providers = [
  'pragmatic',
  'netent',
  'playngo',
  'evoplay',
  'gameart',
  'platipus',
  'betsoft',
  'amatic',
  'wazdan',
  'playson',
  'quickspin',
  'bsw',
  'playtech',
  'dlv',
  'fishing',
  'endorphina',
  'merkur',
  'kajot',
  'wacs',
  'gaminator',
  'mrslotty',
  'igt',
  'greentube',
  'aristocrat',
  'apollo',
  'inbet',
  'konami',
  'austria',
  'flg',
  'cqgaming',
  'relaxgaming',
  'booongo',
  'igrosoft',
  'nolimit',
  'wmg',
  'elbet',
  'redrake',
  'spribe',
  'pragmaticlive',
  'evolutionlive',
  'pragmaticlive',
  'tvbet',
  'xpg',
  'goldenrace',
];

export const daysFilterValue = [
  {
    text: 'today',
    value: 0,
  },
  {
    text: 'yesterday',
    value: -1,
  },
  {
    text: 'lastWeek',
    value: -7,
  },
  {
    text: 'lastMonth',
    value: -31,
  },
  // {
  //   text: 'lastYear',
  //   value: -365,
  // },
];

export const daysFilterValueMobile = [
  {
    text: 'today',
    value: 0,
  },
  {
    text: 'yesterday',
    value: -1,
  },
  {
    text: 'lastWeek',
    value: -7,
  },

];

export const structure = [
  {
    name: 'allUsers',
    value: 'allUsers',
  },
  {
    name: 'directOnly',
    value: 'directOnly',
  },
];

export const searchInItems = [
  {
    name: 'agents',
    value: '6',
  },
  {
    name: 'players',
    value: '0',
  },
];

export const providerItems = [
  {
    name: 'all',
    value: '',
  },
  {
    name: 'PRAGMATIC',
    value: 'PRAGMATIC',
  },
  {
    name: 'PRAGMATIC-NEW',
    value: 'PRAGMATIC-NEW',
  },
  {
    name: 'OUTCOMEBET',
    value: 'OUTCOMEBET',
  },
  {
    name: 'EVOPLAY',
    value: 'EVOPLAY',
  },
  {
    name: 'EVOLUTION',
    value: 'EVOLUTION',
  },
  {
    name: 'TVBET',
    value: 'TVBET',
  },
  {
    name: 'JACKTOP',
    value: 'JACKTOP',
  },
  {
    name: 'FIABLE',
    value: 'FIABLE',
  },
  {
    name: 'BSWGAMES',
    value: 'BSWGAMES',
  },
  {
    name: 'INBET',
    value: 'INBET',
  },
  // {
  //   name: 'SOFTGAMING',
  //   value: 'SOFTGAMING',
  // },
  {
    name: 'SLOTEGRATOR',
    value: 'SLOTEGRATOR',
  },
  {
    name: 'BETRADAR',
    value: 'BETRADAR',
  },
  {
    name: 'LINE1X',
    value: 'LINE1X',
  },
  {
    name: 'FLG',
    value: 'FLG',
  },
];

export const statusBets = [
  {
    name: 'win',
    value: 1,
  },
  {
    name: 'bet',
    value: 2,
  },
  {
    name: 'refund',
    value: 3,
  },
];

export const statusSportBets = [
  {
    name: 'All',
    value: 'All',
  },
  {
    name: 'Accepted',
    value: 'ACCEPTED',
  },
  {
    name: 'Cashed out',
    value: 'CASHED_OUT',
  },
  {
    name: 'Returned',
    value: 'RETURNED',
  },
  {
    name: 'Lost',
    value: 'LOST',
  },
  {
    name: 'Won',
    value: 'WON',
  },
];
export const typesSportBets = [
  {
    name: 'All',
    value: 'all',
  },
  {
    name: 'Single',
    value: 'single',
  },
  {
    name: 'Express',
    value: 'express',
  },
];

export const gameTypes = [
  {
    name: 'all',
    value: 'all',
  },
  {
    name: 'slots',
    value: 'slots',
  },
  {
    name: 'liveCasino',
    value: 'live-casino',
  },
  // {
  //   name: 'virtualGames',
  //   value: 'virtual-games',
  // },
  // {
  //   name: 'sport',
  //   value: 'sport',
  // },
  {
    name: 'fiable',
    value: 'fiable',
  },

];


